import { NavLink, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/', label: 'Home', icon: '🏠' },
  { to: '/snap', label: 'Snap', icon: '📸' },
  { to: '/browse', label: 'Browse', icon: '📚' },
  { to: '/progress', label: 'Progress', icon: '⭐' },
];

export default function TabBar() {
  const location = useLocation();
  if (location.pathname.startsWith('/parent')) return null;

  return (
    <nav className="fixed bottom-0 inset-x-0 bg-white/95 backdrop-blur border-t border-ink/5 safe-bottom z-30">
      <div className="max-w-xl mx-auto grid grid-cols-4 py-2">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-1.5 text-xs font-semibold transition ${
                isActive ? 'text-coral' : 'text-ink/50'
              }`
            }
          >
            <span className="text-xl leading-none">{t.icon}</span>
            {t.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
